import { Flow, BarNote as VexBarNote } from "vexflow";

export class BarNote extends VexBarNote {
  public clone = () => {
    var newBarNote = new Flow.BarNote();
    newBarNote.setType(this.getType());
    const stave = this.getStave();
    if (stave) newBarNote.setStave(stave);

    newBarNote.setTickContext(this.getTickContext());
    return newBarNote;
  };

  public getPlayEvents = (playInfo: any, currentEvents: any) => {
    const newEvents: any[] = [];

    function markBeginRepeatIndex() {
      //mark current index as repeating point
      playInfo.beginRepeatIndex = currentEvents.length + newEvents.length;
    }

    function addRepeatEvents() {
      //Add all events since repeat index
      for (
        var i = playInfo.beginRepeatIndex || 0;
        i < currentEvents.length;
        i++
      ) {
        newEvents.push(currentEvents[i]);
      }
    }

    switch (this.type) {
      case Flow.Barline.type.REPEAT_BEGIN:
        markBeginRepeatIndex();
        break;
      case Flow.Barline.type.REPEAT_END:
        addRepeatEvents();
        break;
      case Flow.Barline.type.REPEAT_BOTH:
        addRepeatEvents();
        markBeginRepeatIndex();
        break;
    }

    return newEvents;
  };
}
